// TourStepsProvider.js
import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { FormControlLabel, Checkbox } from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DoneIcon from "@mui/icons-material/Done";

import { TourGuideHelper } from "./TourGuideHelper";
// import { useTourGuidStoryTrackerContext } from "../../Context/TourGuidContext";
const TourStepsProvider = ({
  currentStepTitle,
  id,
  handleCheckBoxClick,
  localization,
  setGuideTourState,
  isTourDisabled,
  lastIndexKey,
  firstIndexKey,
  tabSelected,
}) => {
  const splitString = (_stringValue) => {
    const _splittedString = _stringValue.split(":");
    return (
      <>
        <b>{_splittedString[0] + ":"}</b>
        {_splittedString[1]}
      </>
    );
  };

  function handleClick() {
    handleCheckBoxClick(id);
  }

  const createContent = (contentText, listItems, isCheckBox) => (
    <div>
      <p className="tooltip_Content">{contentText}</p>
      {isCheckBox && (
        <div className="pt-5">
          <FormControlLabel
            control={
              <Checkbox
                disabled={!isTourDisabled}
                checked={!isTourDisabled}
                onChange={handleClick}
                name="dontShowTour"
                color="primary"
              />
            }
            label={localization.dontShowButton}
          />
        </div>
      )}
      {listItems && (
        <ul className="tooltip_Content">
          {listItems.map((item, index) => (
            <li key={index}>{splitString(item)}</li>
          ))}
        </ul>
      )}
    </div>
  );
  function createLocale(nextText, backText, isLast, skipText) {
    return {
      next: nextText && (
        <span aria-label="Continue" className="continueButtonStyle">
          {nextText || localization.continueButton} <ArrowForwardIcon />
        </span>
      ),
      back: backText && (
        <span aria-label="Back" className="backButtonStyle">
          <ArrowBackIcon /> {backText}
        </span>
      ),
      last: isLast && (
        <span
          aria-label="Finish Tour"
          style={{ display: "flex", alignItems: "center" }}
        >
          {localization.finishToutButton}{" "}
          <DoneIcon
            style={{ marginLeft: "5px", width: "2em", height: "2em" }}
          />
        </span>
      ),
      skip: skipText && ( // Add skip button logic
        <span aria-label="Skip Tour" className="skipButtonStyle">
          {skipText || localization.skipTourButton}
        </span>
      ),
    };
  }

  const tourStepsMapping = {
    1: {
      title: localization.touGuidEquipmentDetailsTitle,
      content: createContent(
        localization.tourGuidEquipmentDetailsContent,
        [],
        firstIndexKey === 1
      ),
      target: "#details",
      afterEquipmentDetails: { value: 1 },
    },
    2: {
      title: localization.touGuidEquipmentInspectionDetailsTitle,
      content: createContent(
        localization.tourGuidEquipmentInspectionDetailsContent,
        [],
        firstIndexKey === 2
      ),
      target: "#orders",
      afterEquipmentDetails: { value: 2 },
    },
    3: {
      title: localization.touGuidEquipmentImageTitle,
      content: createContent(
        localization.tourGuidEquipmentImageContent,
        [],
        firstIndexKey === 3
      ),
      target: "#photo",
      afterEquipmentDetails: { value: 3 },
    },
    4: {
      title: localization.touGuidEquipmentDocumentTitle,
      content: createContent(
        localization.tourGuidEquipmentDocumentContent,
        [],
        firstIndexKey === 4
      ),
      target: "#archivs",
      afterEquipmentDetails: { value: 4 },
    },
    5: {
      title: localization.touGuidEquipmentReapirTitle,
      content: createContent(
        localization.tourGuidEquipmentReapirContent,
        [],
        firstIndexKey === 5
      ),
      target: "#reparation",
      afterEquipmentDetails: { value: 5 },
    },
    6: {
      title: localization.touGuidEquipmentChildrenTitle,
      content: createContent(
        localization.tourGuidEquipmentChildrenContent,
        [],
        firstIndexKey === 6
      ),
      target: "#children",
      afterEquipmentDetails: { value: 6 },
    },
    7: {
      title: localization.tourGuidEquipmentResponsibilityTitle,
      content: createContent(
        localization.tourGuidEquipmentResponsibilityContent,
        [],
        firstIndexKey === 7
      ),
      target: "#responsibilities",
      afterEquipmentDetails: { value: 7 },
    },
    8: {
      title: localization.tourGuideTicketsTitle,
      content: createContent(
        localization.tourGuideTicketsContent,
        [],
        firstIndexKey === 8
      ),
      target: "#Tickets",
      afterEquipmentDetails: { value: 8 },
    },
  };

  // Function to generate the tour steps based on dynamic items
  const generateTourSteps = (items) => {
    return items
      .map((item, index) => {
        const step = tourStepsMapping[item.id];
        if (step) {
          const isLastStep = index === items.length - 1;
          const isFirstStep = index === 0;
          return {
            title: step.title,
            content: step.content,
            locale: createLocale(
              isLastStep ? null : localization.continueButton,
              index === 0 ? null : localization.back,
              isLastStep,
              isFirstStep ? localization.skipTourButton : null
            ),
            styles: isLastStep && {
              buttonNext: {
                backgroundColor: "#0B6BCB",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "6px 24px",
                borderRadius: "4px",
                gap: "12px",
              },
            },
            target: step.target,
            disableBeacon: true,
            lastStep: isLastStep,
            afterEquipmentDetails: step.afterEquipmentDetails,
            placement: "bottom",
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const stepsTour = {
    WelcomeTour: [
      {
        title: localization.tourGuidWelcomeTitle,
        content: createContent(localization.tourGuidWelcomeContent, [], true),

        locale: createLocale(
          localization.continueButton,
          null,
          null,
          localization.skipTourButton
        ),
        data: { next: "/equipmentGrpEqiupment/" },
        placement: "center",
        target: "body",
        disableBeacon: true,
      },
      {
        title: localization.tourGuidNavigationBarTitle,
        content: createContent(localization.tourGuidNavigationContent, [
          localization.tourGuidNavigationContentStep1,
          localization.tourGuidNavigationContentStep2,
          localization.tourGuidNavigationContentStep3,
          localization.tourGuidNavigationContentStep5,
        ]),
        locale: createLocale(localization.continueButton, localization.back),
        placement: "bottom",
        target: "#navgiationBartab",
        disableBeacon: true,
      },
      {
        title: localization.tourGuidSideBarTitle,
        content: createContent(localization.tourGuidSideBarContent, [
          localization.tourGuidSideBarContentStep1,
          localization.tourGuidSideBarContentStep2,
          localization.tourGuidSideBarContentStep3,
        ]),
        locale: createLocale(localization.continueButton, localization.back),
        placement: "right",
        target: "#sidebar",
        disableBeacon: true,
      },
      {
        title: localization.tourGuidDataGridTitle,
        content: createContent(localization.tourGuidDataGridContent),

        locale: createLocale(localization.continueButton, localization.back),
        //    placement: "center",
        target: "#dataGrid",
        disableBeacon: true,
      },
      {
        title: localization.tourGuidDataGridControlTitle,
        content: createContent(localization.tourGuidDataGridContent),
        beforeStep: (step) => {
          const nextCheckDateElement = document.querySelector(".NextCheckDate");
          const nioElement = document.querySelector(".NIO");

          const availableElemnt = nextCheckDateElement
            ? nextCheckDateElement
            : nioElement;
          const virtualScroller = document.querySelector(
            ".MuiDataGrid-virtualScroller"
          );
          if (availableElemnt) {
            TourGuideHelper.adjustScrolling(availableElemnt, virtualScroller);
          }
        },
        locale: createLocale(localization.continueButton, localization.back),
        placement: "bottom",
        target: "#mainGridButton",
        disableBeacon: true,
      },
      {
        title: localization.tourGuidNextCheckDateTitle,
        delayAdded: (step) => {
          const nioElement = document.querySelector(".NIO");
          const virtualScroller = document.querySelector(
            ".MuiDataGrid-virtualScroller"
          );
          TourGuideHelper.adjustScrolling(
            nioElement,
            virtualScroller,
            true,
            setGuideTourState
          );
        },
        content: createContent(localization.tourGuidNextCheckDateContent, [
          localization.tourGuidNextCheckDateStep2,
          localization.tourGuidNextCheckDateStep3,
        ]),

        locale: createLocale(localization.continueButton, localization.back),
        placement: "bottom",
        target: ".NextCheckDate",
        disableBeacon: true,
      },
      {
        title: localization.tourGuidStateTitle,
        content: createContent(localization.tourGuidStateContent, [
          localization.tourGuidStateStep1,
          localization.tourGuidStateStep2,
        ]),

        locale: createLocale(null, localization.back, true),

        styles: {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px 6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
        },
        backHandle: (step) => {
          const nextCheckDateElement = document.querySelector(".NextCheckDate");

          const virtualScroller = document.querySelector(
            ".MuiDataGrid-virtualScroller"
          );
          if (nextCheckDateElement) {
            TourGuideHelper.adjustScrolling(
              nextCheckDateElement,
              virtualScroller,
              true,
              setGuideTourState
            );
          }
        },
        // placement: "bottom",
        disableBeacon: true,
        target: ".NIO",
      },
    ],
    SettingsViewTour: [
      {
        title: localization.organizationSetting,
        content: createContent(
          localization.tourGuidOrganizationSettingContent,
          [],
          true
        ),
        locale: createLocale(
          localization.continueButton,
          null,
          null,
          localization.skipTourButton
        ),
        afterStep: () => {
          const accordion = document.querySelector(".InspectionAccordion");
          const scrollingElement = document.querySelector(".sidebarAccordion");
          TourGuideHelper.scrollTop(accordion, scrollingElement);
        },
        placement: "bottom",
        target: ".sidebarAccordion .Organization",
        disableBeacon: true,
      },
      {
        title: localization.inspectionSetting,
        content: createContent(localization.tourGuidInspectionSettingContent),
        locale: createLocale(localization.continueButton, localization.back),
        afterStep: () => {
          const accordion = document.querySelector(".EquipmentAccordion");

          const scrollingElement = document.querySelector(".sidebarAccordion");
          TourGuideHelper.scrollTop(accordion, scrollingElement);
        },
        placement: "right-end",
        target: ".sidebarAccordion .Inspection",
        disableBeacon: true,
      },
      {
        title: localization.equipmentSetting,
        content: createContent(localization.tourGuidEquipmentSettingContent),
        locale: createLocale(localization.continueButton, localization.back),
        afterStep: () => {
          const accordion = document.querySelector(".GeneralAccordion");
          const scrollingElement = document.querySelector(".sidebarAccordion");
          TourGuideHelper.scrollTop(accordion, scrollingElement);
        },
        placement: "right-end",
        target: ".sidebarAccordion .Equipment",
        disableBeacon: true,
      },
      {
        title: localization.generalSetting,
        content: createContent(localization.tourGuidGeneralSettingContent),
        locale: createLocale(null, localization.back, true),
        styles: {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px 6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
        },
        placement: "top",
        target: ".sidebarAccordion .General",
        disableBeacon: true,
      },
    ],
    EquipmentDetailsViewTour: [
      {
        title: localization.touGuidEquipmentDetailsTitle,
        content: createContent(
          localization.tourGuidEquipmentDetailsContent,
          [],
          firstIndexKey === 1
        ),
        locale: createLocale(
          lastIndexKey === 1 ? null : localization.continueButton,
          firstIndexKey === 1 ? null : localization.back,
          lastIndexKey === 1, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 1 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        afterEquipmentDetails: { value: 1 },
        placement: "bottom",
        target: "#details",
        disableBeacon: true,
        lastStep: lastIndexKey === 1,
      },
      {
        title: localization.touGuidEquipmentInspectionDetailsTitle,
        content: createContent(
          localization.tourGuidEquipmentInspectionDetailsContent,
          [],
          firstIndexKey === 2
        ),
        locale: createLocale(
          lastIndexKey === 2 ? null : localization.continueButton,
          firstIndexKey === 2 ? null : localization.back,
          lastIndexKey === 2, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 2 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#orders",
        afterEquipmentDetails: { value: 2 },
        disableBeacon: true,
        lastStep: lastIndexKey === 2,
      },
      {
        title: localization.touGuidEquipmentImageTitle,
        content: createContent(
          localization.tourGuidEquipmentImageContent,
          [],
          firstIndexKey === 3
        ),
        locale: createLocale(
          lastIndexKey === 3 ? null : localization.continueButton,
          firstIndexKey === 3 ? null : localization.back,
          lastIndexKey === 3, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 3 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#photo",
        afterEquipmentDetails: { value: 3 },
        disableBeacon: true,
        lastStep: lastIndexKey === 3,
      },
      {
        title: localization.touGuidEquipmentDocumentTitle,
        content: createContent(
          localization.tourGuidEquipmentDocumentContent,
          [],
          firstIndexKey === 4
        ),
        locale: createLocale(
          lastIndexKey === 4 ? null : localization.continueButton,
          firstIndexKey === 4 ? null : localization.back,
          lastIndexKey === 4, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 4 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#archivs",
        afterEquipmentDetails: { value: 4 },
        disableBeacon: true,
        lastStep: lastIndexKey === 4,
      },
      {
        title: localization.touGuidEquipmentReapirTitle,
        content: createContent(
          localization.tourGuidEquipmentReapirContent,
          [],
          firstIndexKey === 5
        ),
        locale: createLocale(
          lastIndexKey === 5 ? null : localization.continueButton,
          firstIndexKey === 5 ? null : localization.back,
          lastIndexKey === 5, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 5 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#reparation",
        afterEquipmentDetails: { value: 5 },
        disableBeacon: true,
        lastStep: lastIndexKey === 5,
      },
      {
        title: localization.touGuidEquipmentChildrenTitle,
        content: createContent(
          localization.tourGuidEquipmentChildrenContent,
          [],
          firstIndexKey === 6
        ),
        locale: createLocale(
          lastIndexKey === 6 ? null : localization.continueButton,
          firstIndexKey === 6 ? null : localization.back,
          lastIndexKey === 6, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 6 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#children",
        afterEquipmentDetails: { value: 6 },
        disableBeacon: true,
        lastStep: lastIndexKey === 6,
      },
      {
        title: localization.tourGuidEquipmentResponsibilityTitle,
        content: createContent(
          localization.tourGuidEquipmentResponsibilityContent,
          [],
          firstIndexKey === 7
        ),
        locale: createLocale(
          lastIndexKey === 7 ? null : localization.continueButton,
          firstIndexKey === 7 ? null : localization.back,
          lastIndexKey === 7, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 7 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#responsibilities",
        afterEquipmentDetails: { value: 7 },
        disableBeacon: true,
        lastStep: lastIndexKey === 7,
      },
      {
        title: localization.tourGuideTicketsTitle,
        content: createContent(
          localization.tourGuideTicketsContent,
          [],
          firstIndexKey === 8
        ),
        locale: createLocale(
          lastIndexKey === 8 ? null : localization.continueButton,
          firstIndexKey === 8 ? null : localization.back,
          lastIndexKey === 8, // Pass 'isLast' flag
          localization.skipButton // Add skip button text
        ),
        styles: lastIndexKey === 8 && {
          buttonNext: {
            backgroundColor: "#0B6BCB",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
            gap: "12px",
          },
          buttonSkip: {
            // Add styles for skip button
            backgroundColor: "#F44336",
            color: "#FFFFFF",
            fontSize: "16px",
            padding: "6px 24px",
            borderRadius: "4px",
          },
        },
        placement: "bottom",
        target: "#Tickets",
        afterEquipmentDetails: { value: 8 },
        disableBeacon: true,
        lastStep: lastIndexKey === 8,
      },
    ],
  };

  // Return the steps based on the current step index
  if (currentStepTitle === "EquipmentDetailsViewTour") {
    return generateTourSteps(tabSelected);
  } else {
    return stepsTour[currentStepTitle];
  }
};

export default TourStepsProvider;
